import { render } from "./ProductHorizontal.vue?vue&type=template&id=32066187"
import script from "./ProductHorizontal.vue?vue&type=script&lang=js"
export * from "./ProductHorizontal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__